module.exports = __webpack_public_path__ + "img/9_004.56d607d5.webp";